module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "assignments"
  }, [_vm._v("\n    " + _vm._s(_vm.getCourses) + "\n    "), (_vm.currentTerm) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/img/assignment-icon.png")
    }
  }), _vm._v("Assignments"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('A sortable assignment table including due dates, marks and recorded feedback.'),
      expression: "'A sortable assignment table including due dates, marks and recorded feedback.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), (_vm.hasCourseSets && _vm.currentTerm.courseSets && _vm.currentTerm.courseSets.length > 0) ? _c('div', {
    staticClass: "course-set-switcher"
  }, [_c('ul', _vm._l((_vm.currentTerm.courseSets), function(set) {
    return _c('li', [_c('span', {
      class: {
        'selected': _vm.currentTerm.selectedCourseSet == set.id
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectCourseSet(set.id)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(set.name) + "\n                        ")])])
  }))]) : _vm._e()]), _vm._v(" "), (_vm.courses) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('assignments-table', {
    attrs: {
      "courses": _vm.courses
    }
  })], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8de4c9e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Assignments.vue
// module id = 2100
// module chunks = 2